import { getAbsoluteRoute } from "@/lib/utils/utils";

export async function fetchImages(count: number = 10, skip: number = 0) {
  try {
    const response = await fetch(
      getAbsoluteRoute(`/api/image/list?count=${count}&skip=${skip}`),
      {
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}, ${await response.text()}`,
      );
    }
    const data = await response.json();
    // console.log("data", data.images);
    return data.images;
  } catch (error: any) {
    console.error("Error fetching images:", error?.message);
    return;
  }
}
